import Header from "../Components/Header/Header";
import Parser from 'html-react-parser';
import { useParams } from "react-router-dom";
import { API } from "../constant";
import { useState, useEffect } from 'react';
import Loading from "../Components/Hooks/Loading";
import "./faq.css";
import Faq from "./Faq";
import Page from "./Page";

const Pages = () =>{

    const [pageData, setPageData] = useState();
    const [loading, setLoading] = useState();
    const [activePanel, setActivePanel] = useState(false);
    const {slug} = useParams();

    useEffect(() => {
        setLoading(true);
        fetch(`${API}/Pages/?filters[slug][$eq]=${slug}&populate=*`)
        .then((res) => {
            return res.json();
        })
        .then((data) => {
            const Data = data.data?data.data[0].attributes:"No data found";
            // console.log(data);
            setPageData(Data); 
        });  
        setLoading(false); 
    }, [slug]);
   
    if(loading || pageData==undefined)
        return <Loading/>

//    console.log(pageData);
if(slug ==='faq')
    return <Faq data={pageData}/>
else
    return <Page data={pageData}/>
}
export default Pages;